<div class="dropdown">
  <div class="dropdown-header flex items-center justify-between">
    <div>
      <div class="dropdown-heading">התראות</div>
      <div class="dropdown-subheading">
        יש לך {{ notifications.length }} התראות
      </div>
    </div>

    <button [matMenuTriggerFor]="settingsMenu" mat-icon-button type="button">
      <mat-icon
        class="notifications-header-icon"
        svgIcon="mat:settings"></mat-icon>
    </button>
  </div>

  <div class="dropdown-content">
    <div *ngIf="loading" class="p-4 text-center text-secondary">טוען...</div>

    <div *ngIf="!loading && notifications.length === 0" class="p-4 text-center text-secondary">
      אין התראות חדשות
    </div>

    <a
      *ngFor="let notification of notifications; trackBy: trackById"
      (click)="open(notification)"
      [class.read]="notification.read"
      class="notification flex items-center"
      matRipple>
      <mat-icon
        [ngClass]="notification.colorClass"
        [svgIcon]="notification.icon"
        class="notification-icon flex-none"></mat-icon>
      <div class="flex-auto">
        <div class="notification-label">{{ notification.label }}</div>
        <div class="notification-description">
          {{ notification.datetime | vexDateFormatRelative }}
        </div>
      </div>
      <mat-icon
        class="notification-chevron flex-none"
        svgIcon="mat:chevron_right"></mat-icon>
    </a>
  </div>

  <div class="dropdown-footer flex items-center justify-center">
    <button (click)="markAllRead($event)" color="primary" mat-button type="button">
      סמן הכל כנקרא
    </button>
  </div>
</div>

<mat-menu #settingsMenu="matMenu" xPosition="before" yPosition="below">
  <button (click)="markAllRead($event)" mat-menu-item>
    <mat-icon svgIcon="mat:clear_all"></mat-icon>
    <span>סמן הכל כנקרא</span>
  </button>
</mat-menu>
